import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  type DictationSessionEndPorts,
  type TrackDictationCompleted,
  type TrackDictationErrored,
  type TrackDictationStarted,
} from '@heidi/dictate/contracts';

/**
 * App-side emit hosts for the dictation session funnel (`@heidi/dictate`).
 *
 * ROUTING: NO `options`, so these three DO reach Amplitude — the wrappers they
 * replace passed no destination control. The CSAT host next door is the opposite;
 * matching it here would silently stop three Amplitude series.
 *
 * The enum member, not `dictationStarted.name`: `event_name` discriminates
 * `TrackingEventV2` on string ENUM members. The suite asserts they agree.
 */

export const trackDictationStarted: TrackDictationStarted = (props) => {
  track({
    event_name: TrackingEventName.DictationStarted,
    props,
  });
};

export const trackDictationCompleted: TrackDictationCompleted = (props) => {
  track({
    event_name: TrackingEventName.DictationCompleted,
    props,
  });
};

export const trackDictationErrored: TrackDictationErrored = (props) => {
  track({
    event_name: TrackingEventName.DictationErrored,
    props,
  });
};

/**
 * The pair `trackDictationSessionEnd` and its four call sites bind, replacing the
 * `store.dispatch` they used to hand over. A module constant so it is the same
 * object every time and cannot re-fire an effect that depends on it.
 */
export const dictationSessionEndPorts: DictationSessionEndPorts = {
  trackCompleted: trackDictationCompleted,
  trackErrored: trackDictationErrored,
};
